// extracted by mini-css-extract-plugin
export default {"sticky":"GrowOnScroll_sticky__PR5Zb","grow-on-scroll":"GrowOnScroll_grow-on-scroll__spqOp"};